import { CreateUpdateDashboardContact, CreateUpdateDashboardNotice, DashboardContact, DashboardNotice } from "./types";

export const convertDashboardContactToCreateUpdateObject = (
  contact: DashboardContact
): CreateUpdateDashboardContact => {
  const { id, createdAt, updatedAt, institution, agent, ...data } = contact;

  return { ...data, institutionId: institution?.id, agentId: agent?.id };
};

export const convertDashboardNoticeToCreateUpdateObject = (notice: DashboardNotice): CreateUpdateDashboardNotice => {
  const { id, createdAt, updatedAt, attachments, ...data } = notice;

  return data;
};
